<template>
  <v-container fluid fill-height align-start ma-0 pa-2>
    <v-row no-gutters>
      <v-col cols="12" sm="12" lg="12" class="pa-2">
        <i-card-vertical
          headerTitle="그리드표준 템플릿"
          :useBtnList="buttonUseList"
          @btnAdd="btnAdd()"
          @btnSearch="btnSearch()"
          @btnSave="btnSave()"
          @btnDelete="btnDelete()"
        >
          <template v-slot:body>
            <!-- 로딩창 -->
            <v-btn @click="showLoadPanel"> 로딩 </v-btn>
            <DxLoadPanel
              :position="position"
              :visible="loadingVisible"
              :show-indicator="showIndicator"
              :show-pane="showPane"
              :shading="false"
              :close-on-outside-click="closeOnOutsideClick"
              :on-shown="onShown"
              shading-color="rgba(0,0,0,0.4)"
              message="조회중..."
            />

            <!-- 팝업 -->
            <v-btn @click="showInfo"> 경고 </v-btn>
            <DxPopup
              :visible="popupVisible"
              :drag-enabled="false"
              :close-on-outside-click="true"
              :show-close-button="false"
              :show-title="false"
              :width="auto"
              :shading="false"
              :height="auto"
              container=".dx-viewport"
            >
              <DxPosition at="center" my="center" :of="positionOf" />
              <DxToolbarItem :visible="closeVisible" widget="dxButton" toolbar="bottom" location="after" :options="closeButtonOptions" />
              <DxToolbarItem :visible="yesVisible" widget="dxButton" toolbar="bottom" location="after" :options="yesButtonOptions" />
              <DxToolbarItem :visible="noVisible" widget="dxButton" toolbar="bottom" location="after" :options="noButtonOptions" />
              <p>
                <span>{{ currentMsg }}</span>
              </p>
            </DxPopup>

            <v-btn @click="dangerClick"> 에러 </v-btn>

            <!-- <v-btn @click="choiceClick"> 선택 </v-btn> -->

            <v-btn @click="showChoice"> 선택 </v-btn>

            <v-layout column layout-col-height0 overflow-auto>
              <v-col cols="12" md="12" class="row pa-0">
                <v-col cols="12" lg="12" class="mt-2">
                  <DxDataGrid id="gridContainer" :data-source="templateGridTestDataSourece" :remote-operations="true" :show-borders="true">
                    <DxPaging :page-size="15" />

                    <DxColumn data-field="id" width="80" />
                    <DxColumn data-field="title" />
                    <DxMasterDetail :enabled="true" template="master-detail" />
                    <template #master-detail="{ data }">
                      <Advanced-detail-view :master-detail-data="data" />
                    </template>
                  </DxDataGrid>
                </v-col>
              </v-col>
            </v-layout>
          </template>
        </i-card-vertical>
        <!-- <v-btn @click="loadingClick"> 로딩 </v-btn>
        <v-btn @click="warningClick"> 경고 </v-btn>
        <v-btn @click="dangerClick"> 에러 </v-btn>
        <v-btn @click="choiceClick"> 선택 </v-btn> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import iCardVertical from '@/components/common/iCardVertical.vue'
import { DxDataGrid, DxColumn, DxPaging, DxMasterDetail } from 'devextreme-vue/data-grid'
import notify from 'devextreme/ui/notify'
import DxLoadPanel from 'devextreme-vue/load-panel'
import { DxPopup, DxPosition, DxToolbarItem } from 'devextreme-vue/popup'
import AdvancedDetailView from './AdvancedDetailView.vue'

export default {
  components: {
    iCardVertical,
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxMasterDetail,
    AdvancedDetailView,
    DxLoadPanel,
    DxPopup,
    DxPosition,
    DxToolbarItem
  },
  data() {
    return {
      //dxLoadPanel
      loadingVisible: false,
      showIndicator: true,
      showPane: false,
      closeOnOutsideClick: false,
      position: { of: '.container' },

      //dxPopup
      popupVisible: false,
      positionOf: '.container',
      closeButtonOptions: {
        text: '확인',
        onClick: () => {
          this.popupVisible = false
        }
      },
      yesButtonOptions: {
        text: '예',
        onClick: () => {
          this.popupVisible = false
        }
      },
      noButtonOptions: {
        text: '아니오',
        onClick: () => {
          this.popupVisible = false
        }
      },

      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        'btnSave', //저장
        'btnDelete' //삭제
      ],
      templateGridTestDataSourece: [
        {
          id: 1,
          title: '안녕하세요'
        },
        {
          id: 2,
          title: '감사해요'
        },
        {
          id: 3,
          title: '잘있어요'
        },
        {
          id: 4,
          title: '다시만나요'
        },
        {
          id: 1,
          title: '안녕하세요'
        },
        {
          id: 2,
          title: '감사해요'
        },
        {
          id: 3,
          title: '잘있어요'
        },
        {
          id: 4,
          title: '다시만나요'
        },
        {
          id: 1,
          title: '안녕하세요'
        },
        {
          id: 2,
          title: '감사해요'
        },
        {
          id: 3,
          title: '잘있어요'
        },
        {
          id: 4,
          title: '다시만나요'
        },
        {
          id: 1,
          title: '안녕하세요'
        },
        {
          id: 2,
          title: '감사해요'
        },
        {
          id: 3,
          title: '잘있어요'
        },
        {
          id: 4,
          title: '다시만나요'
        }
      ]
    }
  },
  beforeMount() {},
  methods: {
    //로딩창 dxLoadPanel
    showLoadPanel() {
      this.loadingVisible = true
    },
    onShown() {
      setTimeout(() => {
        this.loadingVisible = false
      }, 3000)
    },
    onHidden() {
      return false
    },
    //팝업창 dxPopup
    showInfo() {
      this.currentMsg = '경고'
      this.popupVisible = true
      this.closeVisible = true
      this.noVisible = false
      this.yesVisible = false
    },
    showChoice() {
      this.currentMsg = '선택하시겠습니까'
      this.popupVisible = true
      this.closeVisible = false
      this.noVisible = true
      this.yesVisible = true
    },
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    btnSearch() {},
    btnAdd() {},
    btnSave() {},
    btnDelete() {}
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    // loadingClick() {
    //   this.$vToastify.loader({
    //     title: this.$t('working'),
    //     body: this.$t('작업중입니다.')
    //   })
    // },
    // warningClick() {
    //   this.$vToastify.warning({ body: '경고입니다.' })
    // },
    // dangerClick() {
    //   this.$vToastify.error({ body: '에러입니다.' })
    // },
    // choiceClick() {
    //   this.$vToastify.prompt({
    //     body: '선택하시겠습니까?',
    //     answers: { Yes: true, No: false }
    //   })
    // }
  }
}
</script>

<style>
/* #container {
  padding: 10px;
}

#container ul {
  list-style-type: none;
  text-align: center;
}

#container ul li {
  display: inline-block;
  width: 160px;
  margin: 10px;
}

#container ul li img {
  width: 100px;
}

.button-info {
  margin: 10px;
}

.dx-popup-content p {
  margin-bottom: 10px;
  margin-top: 0;
} */
</style>
